import Layout from '@/views/Layout'

import layoutRouteConfig from './layout-route-config'

const layoutRoutes = layoutRouteConfig.map(config => ({
  path: `/${config.name}`,
  name: config.name,
  meta: config.meta,
  component: Layout,
  redirect: config.redirect,
  hidden: config.hidden === true,
  out: config.out===true,
  children: config.children ? config.children.map(child => ({
    name: `${config.name}-${child.name}`,
    path: child.name,
    component: async () => {
      const com = await child.component()
      com.default.name = `${config.name}-${child.name}`
      return com
    },
    meta: child.meta,
    hidden: child.hidden === true,
    out: child.out===true
  })) : undefined
}))

export const routes = [{
    name: 'login',
    path: '/login',
    component: () => import('@/views/Login'),
    hidden: true
  },
  {
    name: 'forget-pass',
    path: '/forget-pass',
    component: () => import('@/views/Login/forget'),
    hidden: true
  },
  {
    name: '404',
    path: '/404',
    component: () => import('@/views/ErrorPage/404'),
    hidden: true
  },
  {
    name: '401',
    path: '/401',
    component: () => import('@/views/ErrorPage/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    name: 'dashboard',
    redirect: '/dashboard',
    meta: { title: 'Dashboard'},
    children: [{
      name: 'dashboard',
      path: 'dashboard',
      component: () => import('@/views/Dashboard'),
      meta: { title: 'Dashboard',
        // icon: 'dashboard',
        noCache: true }
    }]
  },
  { path: '*', redirect: '/404', hidden: true },
  ...layoutRoutes
]
